import { FormControl } from "@mui/joy";
import { ControlPosition, MapControl, useMapsLibrary } from "@vis.gl/react-google-maps";
import { InputText } from "primereact/inputtext";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";

type CustomAutocompleteControlProps = {
  controlPosition: ControlPosition;
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
  location: google.maps.LatLngLiteral;
  setGps: Dispatch<google.maps.LatLngLiteral>;
  setAddress: Dispatch<string>;
};

export const CustomMapControl = ({
  controlPosition,
  onPlaceSelect,
  location,
  setGps,
  setAddress,
}: CustomAutocompleteControlProps) => {
  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary("places");

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options: google.maps.places.AutocompleteOptions = {
      fields: ["geometry", "name", "formatted_address"],
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener("place_changed", () => {
      const placeChange = placeAutocomplete.getPlace();
      console.log("placeChange", placeChange);
      onPlaceSelect(placeAutocomplete.getPlace());
      setGps({
        lat: +(placeChange.geometry?.location?.lat() || 0),
        lng: +(placeChange.geometry?.location?.lng() || 0),
      });
    });
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <MapControl position={controlPosition}>
      <div className="autocomplete-control">
        <div className="autocomplete-container">
          <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
            <InputText
              ref={inputRef}
              style={{ width: "40vw", marginTop: 25 }}
              type="text"
              className="p-inputtext-sm PrimeSmallInput"
              placeholder="Enter Location"
            />
          </FormControl>
        </div>
      </div>
    </MapControl>
  );
};
